import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { createProgressSteps } from "./utils/createProgressSteps";

type CourseSetupProgressProps = {
  uploadedMaterials?: number;
  createdQuestions?: number;
  fileUploadRef: React.RefObject<HTMLDivElement | null>;
};

const CourseSetupProgress = ({
  uploadedMaterials,
  createdQuestions,
  fileUploadRef,
}: CourseSetupProgressProps) => {
  const { t } = useTranslation(["coursePage", "commons"]);
  const navigate = useNavigate();

  const steps = createProgressSteps({
    uploadedMaterials,
    createdQuestions,
    fileUploadRef,
    navigate,
  });

  const isAllComplete = steps.every((step) => step.isComplete);

  const progressPercentage = isAllComplete
    ? 100
    : Math.round(
        (steps.filter((s) => s.isComplete).length / steps.length) * 100,
      );

  return (
    !isAllComplete && (
      <div className="collapse-arrow collapse border border-0 border-base-300 bg-neutral shadow-xl md:mt-4 md:mr-sm md:min-w-72">
        <input type="checkbox" />
        <div className="collapse-title font-semibold">
          {t("courseSetupTracker.courseSetup")} ({progressPercentage} %)
        </div>
        <div className="collapse-content text-sm">
          <ul className="steps steps-vertical mt-2 w-full">
            {steps.map((step) => (
              <li
                key={step.label}
                className={`step rounded-xl hover:bg-neutral-800/20 ${step.isComplete ? "step-primary" : ""}`}
                onClick={step.onClick}
                onKeyDown={(event) => {
                  if (
                    step.onClick &&
                    (event.key === "Enter" || event.key === " ")
                  ) {
                    event.preventDefault();
                    step.onClick();
                  }
                }}
                tabIndex={step.onClick ? 0 : -1}
                role={step.onClick ? "button" : undefined}
                style={{ cursor: step.onClick ? "pointer" : "default" }}
              >
                <span>{step.label}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    )
  );
};

export default CourseSetupProgress;
